import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo-hooks';

import ActCard from '../../components/ActCard';

export const ACTS_QUERY = gql`
  query acts {
    acts {
      id
      name
      searches {
        id
        act {
          id
          name
        }
        name
        lang
        concepts {
          id
          index
          json
        }
      }
    }
  }
`;

const ACT_SEARCHES_QUERY = gql`
  query {
    actSearches {
      id
      act {
        id
        name
      }
      name
      lang
      concepts {
        id
        index
        json
      }
    }
  }
`;

const ActSearches = props => {
  const { loading, error, data, refetch } = useQuery(ACTS_QUERY, {
    fetchPolicy: 'cache-then-network',
    notifyOnNetworkStatusChange: true
  });

  if (error) {
    return null;
  }

  if (loading) {
    return (
      <div className="acts">
        <div className="acts-header">
          <div className="acts-header-title">Speech Actit</div>
        </div>
      </div>
    );
  }

  return (
    <div className="acts">
      <div className="acts-header">
        <div className="acts-header-title">Speech Actit</div>
      </div>
      <div className="acts-items">
        <div className="acts-items-grid">
          {data &&
            data.acts &&
            data.acts
              .sort((a, b) => a.id - b.id)
              .map(act => {
                return (
                  <Link
                    key={act.id}
                    to={`/acts/${act.name}`}
                    className="default"
                  >
                    <ActCard
                      key={act.id}
                      {...act}
                      searchCount={act.searches.length}
                    />
                  </Link>
                );
                /*try {
                  return <div key={act.id} className="act-item"><div className="act-item-name">{act.name}</div><div</div></div>;
                  const parsedSearc = {
                    ...act.search,
                    concepts: act.concepts.map(concept => ({
                      ...concept,
                      json: JSON.parse(concept.json)
                    }))
                  };
                  return <ActSearchCard key={parsedAct.id} {...parsedAct} />;
                } catch (e) {
                  return <div key={act.id}>{JSON.stringify(act)}</div>;
                }*/
              })}
        </div>
      </div>
    </div>
  );
};

export default ActSearches;
